import React from "react";
import { Route, Routes } from "react-router-dom";
import { PAGES_PATH } from "../../../navigation/params";
import GvPaymentHistoryContainer from "../GvPaymentHistoryContainer/GvPaymentHistoryContainer";
import GvPaymentLandingContainer from "../GvPaymentLandingContainer/GvPaymentLandingContainer";
import GvPaymentMethodContainer from "../GvPaymentMethodContainer/GvPaymentMethodContainer";
import PastPlansContainer from "../PastPlansContainer/PastPlansContainer";

// TODO: Move this file to routing folder during cleanup

const PaymentRoutingContainer = () => {
  return (
    <Routes>
      <Route path={PAGES_PATH.BILLING_HISTORY} element={<GvPaymentHistoryContainer />} />
      <Route path={PAGES_PATH.BILLING_METHOD} element={<GvPaymentMethodContainer />} />
      <Route path={PAGES_PATH.PAST_PLANS} element={<PastPlansContainer />} />
      <Route path="/" element={<GvPaymentLandingContainer />} />
    </Routes>
  );
};

export default PaymentRoutingContainer;
